<template>
    <transition name="fade" :duration="{ leave: 800, enter: 800 }">
        <div class="swap-item-container" v-show="!closed">
            <div style="height: calc(100% - 20px); margin: 15px auto;" ref="slideImageContainer" v-if="shouldLoadImg" >
                <spinner :show="!imgLoading.isLoaded" />
                <img :class="{'slideshow-zoom__image--hide': !imgLoading.isLoaded, 'slideshow-zoom__image': true}" ref="slideImage" style="left: 0;" :src="product ? apiImageUrl(images[index]) : imageUrl(images[index])" v-images-loaded="imgLoaded" />
            </div>
            <img @click.stop="closeModal" style="top: calc(100% - 60px);" class="close-modal" :src="imageUrl('close-modal.png')"/>
        </div>
    </transition>
</template>

<script>
    import Mixins from "../../mixins/mixins";
    import Spinner from './spinner.vue';
    import $ from 'webpack-zepto';
    import PinchZoom from 'pinch-zoom-js';
    import imagesLoaded from 'vue-images-loaded';

    export default {
        data() {
            return {
                substituteProducts: [],
                noProductsFoundMessage: false,
                closed: true,
                imgPZContainer: null,
                imgLoading: {
                    isLoaded: false,
                },
                shouldLoadImg: true,
            }
        },
        directives: {
            imagesLoaded,
        },
        components: {
            Spinner,
        },
        props: ['images', 'index', 'product'],
        mixins: [Mixins],
        methods: {
            closeModal() {
                this.$store.commit('menu/resetHeader');
                this.$parent.$emit('closeModal');
                this.$emit('close-modal');
                this.closed = true;
                this.$refs.slideImageContainer.removeChild(this.imgPZContainer.container);
                this.imgPZContainer = null;
                this.shouldLoadImg = false;
                this.$nextTick(() => {
                    this.shouldLoadImg = true;
                });
            },
            opened() {
                if(this.$refs.slideImage){
                    if(this.closed) this.$store.commit('menu/hideHeader');
                    this.closed = false;
                    this.$nextTick(() => {
                        this.imgPZContainer = new PinchZoom(this.$refs.slideImage, {
                            draggableUnzoomed: false
                        });
                        this.imgPZContainer.enable();
                    });
                }
            },
            imgLoaded() {
                this.imgLoading = {
                    src: this.images[this.index],
                    isLoaded: true,
                };
                this.imgPZContainer?.enable();
            },
        },
        mounted() {
            setTimeout(
                () => {
                    $('.replacement').addClass('fade-in');
                }, 200);
        },
        watch: {
            images() {
                this.imgLoading = {
                    src: this.images[this.index],
                    isLoaded: this.images[this.index] == this.imgLoading.src,
                };
            },
            index() {
                this.imgLoading = {
                    src: this.images[this.index],
                    isLoaded: this.images[this.index] == this.imgLoading.src,
                };
            },
        }
    }
</script>

<style scoped>
    .slideshow-zoom__image {
        transition: 0.3s ease-in opacity;
    }
    .slideshow-zoom__image--hide {
        opacity: 0;
    }
</style>
